import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';

import { ApiService }    from '../api/api.service';
import { CustomerModel } from '../customers/models/customer';
import { InvoiceModel }  from './models/invoice';
import { Table }         from '../table/types/table';

@Component({
  selector   : 'wor-invoices-for-biller-payment',
  template: require('./invoices.for-biller-payment.component.html')
})
export class InvoicesForBillerPaymentComponent implements OnInit {
  @Input() billers  : Array<CustomerModel>;
  @Input() isVendor : boolean;

  invoices        : Array<InvoiceModel> = [];
  isFlipped       = false;
  selectedBiller  : CustomerModel;
  selectedInvoices: Array<InvoiceModel> = [];

  billerTableSettings : Table;
  invoiceTableSettings: Table;

  constructor (
    public  activeModal     : NgbActiveModal,
    private apiService      : ApiService,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {
    this.billerTableSettings = {
      columns: [
        {
          field : this.isVendor ? 'company_name' : 'display_name',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.COMPANY')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND', {
          type: this.translateService.instant('COMPANY_SPACE.BILLER')
        })
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      },
      static: true
    };

    this.invoiceTableSettings = {
      columns: [
        {
          field : this.isVendor ? 'vendor_invoice_number' : 'invoice_number',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
          }
        },
        {
          field   : 'post_date',
          header  : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
          },
          pipe    : 'date',
          pipeArgs: [ 'mediumDate' ]
        },
        {
          field : 'total',
          header: {
            text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
          },
          pipe: 'globalCurrency'
        },
        {
          field : 'balance_due',
          header: {
            text: this.translateService.instant('JS_SPACE.COLUMNS.BALANCE')
          },
          pipe: 'globalCurrency'
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true,
          multi  : true
        }
      },
      sorting: {
        enabled: false
      },
      static: true
    };
  }

  areAllSelected (): boolean {


    return this.invoices.length > 0 && this.invoices.length === this.selectedInvoices.length;


  }

  flip (): void {


    this.isFlipped = !this.isFlipped;


  }

  handleInvoiceClick (): void {


    this.selectedInvoices = this.invoices.filter(invoice => invoice.selected);


  }

  selectBiller ( biller ?: CustomerModel ): void {
    this.selectedBiller = biller || this.billers.filter(b => b.selected)[0];

    const url = this.isVendor
      ? '/vendors/invoice_list'
      : '/customers/invoice_list';

    const data = this.isVendor
      ? [ this.selectedBiller.id, 0, '*', 'P', 'I', '*', '*', '*', 'post_date', 'desc' ]
      : [ this.selectedBiller.id, 0, '*', 'P', 'I', 'post_date', 'desc' ];

    this.apiService.get(url, data)
    .then(( invoices: Array<InvoiceModel> = [] ) => {
      this.invoices = invoices;
      this.flip();
    });
  }

  toggleAll (): void {
    if (this.areAllSelected()) {
      this.invoices.forEach(invoice => { invoice.selected = false; });
      this.selectedInvoices = [];
    }
    else {
      this.invoices.forEach(invoice => { invoice.selected = true; });
      this.selectedInvoices = this.invoices;
    }
  }
}
